<template>
  <div class="user">
    <z-update-org-user ref="updateOrgUser" @updateSuccess="refreshTree"></z-update-org-user>
    <a-row :gutter="24" class="org-user" style="margin-left: -16px; margin-right: -16px;">
    <a-col  :xs="{span:24}" :sm="{span:12}" :lg="{span:8}">
      <div class="antd-pro-components-description-list-index-term" style="white-space: nowrap">{{$t('org.userName')}}
      </div>
      <div class="antd-pro-components-description-list-index-detail">{{user ? user.username : ''}}</div>
    </a-col>

    <a-col  :xs="{span:24}" :sm="{span:12}" :lg="{span:8}">
      <div class="antd-pro-components-description-list-index-term" style="white-space: nowrap">{{$t('org.role')}}</div>
      <!-- <div class="antd-pro-components-description-list-index-detail">{{user ? lang == 'en' ? user.roles[0].name : user.roles[0].description : ''}}
      </div> -->
      <div class="antd-pro-components-description-list-index-detail">{{user ? $t('org.'+user.roles[0].name) : ''}}
      </div>
    </a-col>

    <a-col  :xs="{span:24}" :sm="{span:12}" :lg="{span:8}">
      <div class="antd-pro-components-description-list-index-term" style="white-space: nowrap">{{$t('org.nickName')}}
      </div>
      <div class="antd-pro-components-description-list-index-detail">{{user ? user.nickname : ''}}</div>
    </a-col>

    <a-col  :xs="{span:24}" :sm="{span:12}" :lg="{span:8}">
      <div class="antd-pro-components-description-list-index-term" style="white-space: nowrap">{{$t('org.phone')}}</div>
      <div class="antd-pro-components-description-list-index-detail">{{user ? user.phone : ''}}</div>
    </a-col>

    <a-col  :xs="{span:24}" :sm="{span:12}" :lg="{span:8}">
      <div class="antd-pro-components-description-list-index-term" style="white-space: nowrap">{{$t('org.autoRefresh')}}
      </div>
      <div class="antd-pro-components-description-list-index-detail">
        {{user.autoRefresh ? $t('org.refresh') : $t('org.autoOver')}}</div>
    </a-col>

    <a-col style="padding-left:16px;padding-right:16px;line-height: 20px;color: rgba(0, 0, 0, 0.85)" :xs="{span:24}"
      :sm="{span:12}" :lg="{span:8}">
      <div style="white-space: nowrap;float:left">{{$t('org.avatar')}}：</div>
      <div class="antd-pro-components-description-list-index-detail">
        <!-- <a-avatar size="large" v-if="user && user.imageUrl" :src= "user.imageUrl"/> -->
        <img style="max-width: 20px" v-if="user && user.imageUrl" :src="user.imageUrl" alt="LOGO">
        <span v-else>---</span>
      </div>
    </a-col>
  </a-row>
  <div class="action">
    <a-button @click="editUserInfo" :disabled="roles.includes('Attach')" size="small" type="primary">{{$t('global.edit')}}</a-button>
    <a-button size="small" @click="deleteUser" :disabled="(user.isMaster || roles.includes('Attach')) ? true : false" type="danger">{{$t('global.delete')}}</a-button>
    <!-- {{user}} -->
  </div>
  </div>
</template>
<script>
  import config from '../../config'
  import ZUpdateOrgUser from '@/views/org/UpdateOrgUser.vue'
  import {mapGetters} from 'vuex'
  export default {
    components: {
      ZUpdateOrgUser,
    },
    props: {
      user: {
        required: true,
        type: Object
      },
      orgId: {
        required: true,
      }
    },
    computed: {
      ...mapGetters(['roles','lang'])
    },
    methods: {
      deleteUser () {
        // console.log(this.$confirm)
        this.$confirm({
          title: this.$t('global.sureDelete'),
          onOk: () => {
            // console.log('ok')
            this.$http.delete(config.api.delete_attache_user + this.user.id).then((res) => {
              // console.log(res)
              let {code, desc, result} = res
              if (code === 0) {
                this.$emit('refresh')
                this.$notification.success({
                  message: this.$t('global.deleteUserSuccessTip')
                })
              } else {
                this.$notification.error({
                  message: desc
                })
              }
            })
          },
          onCancel: () => {
            console.log('quit')
          }
        })
      },
      // 打开编辑框
      editUserInfo(org){
        this.$refs["updateOrgUser"].showModel(this.user,this.orgId)
      },
      // 完成修改后的事件
      refreshTree () {
        this.$emit('refresh')
      }
    }
  }
</script>
<style lang="less" scoped>
.user {
  width: 90%;
  display: grid;
  grid-template-columns: 4fr 1fr;
  // justify-content: center;
  align-items: center;
  border-bottom: 1px solid #444;
  .org-user {
    padding-top: 10px;
    width: 90%;
    margin-top: 10px; 
  }
}
</style>